import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { ICommandBase } from '@Quest/cqrs';
import { SaveViewFinishedProjectsPageCommandV1 } from "@Quest/Portfolios/Domain/commands-core";
import PortfoliosCommands from "@Quest/Portfolios/Domain/commands-vue-component";
import PortfoliosQueries from "@Quest/Portfolios/Domain/queries-vue-component";
import { FinishedProjectsPageReadModel } from '@Quest/Portfolios/Domain/readmodels';
import { ProjectResumedLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectResumedLifecycleSetter";
import ProjectResumedLifecycleSetter from '@Quest/Projects/Components/ProjectResumedLifecycleSetter.vue';
import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid";
import ProjectsGrid from "@Quest/Projects/Components/ProjectsGrid.vue";
import { SetLifecycleResumedCommandV1 } from "@Quest/Projects/Domain/commands-core";
import ProjectsCommands from "@Quest/Projects/Domain/commands-vue-component";
import { GridProjectReadModel } from '@Quest/Projects/Domain/readmodels';
import Vue from "vue";
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioNavigation, ProjectsGrid, ProjectResumedLifecycleSetter
    }
})
export default class FinishedProjectsPage extends mixins(PortfoliosQueries, PortfoliosCommands, ProjectsCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }

    rm: FinishedProjectsPageReadModel | null = null;
    get projects(): GridProjectReadModel[] { return this.rm?.Projects ?? []; }
    get portfolioId() { return this.rm.PortfolioId; }
    get portfolioName(): string | null { return this.rm?.PortfolioName; }


    grid: ProjectsGridViewModel = new ProjectsGridViewModel();
    projectResumedLifecycleSetter: ProjectResumedLifecycleSetterViewModel = new ProjectResumedLifecycleSetterViewModel();


    handleShowGridColumnsEditor()
    {
        this.grid.showGridColumnsEditor();
    }

    handleSaveViewSettings()
    {
        const grid = this.grid.getJson();
        this.invokeSaveViewFinishedProjectsPageCommandV1(this.workspaceId, this.portfolioId, grid)
    }

    handleClearGridFilters()
    {
        this.grid.clearFilters();
    }

    handleExportGrid()
    {
        this.grid.exportGrid();
    }


    handleResumed(projectId: string)
    {
        this.invokeSetLifecycleResumedCommandV1(this.workspaceId, this.portfolioId, projectId);
    }

    mounted()
    {
        document.title = "Portfolio Finished | TransparentChoice";
        this.runFinishedProjectsPageQueryV1(this.workspaceId, this.tchProjectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "FinishedProjectsPageReadModel")
        {
            this.rm = model as FinishedProjectsPageReadModel;

            Vue.nextTick(() =>
            {
                this.grid.renderGrid(this.rm.Grid.IdField, this.rm.Grid.Fields, this.rm.Grid.DefaultFieldIds, this.rm.Grid.Options);
                this.grid.setProjects(this.rm.Projects.map(p => p.Properties));
            })
        }
        else if (modelName === "GridProjectReadModel")
        {
            const rm = model as GridProjectReadModel;

            this.rm.Projects = this.rm.Projects.filter(p => p.Id !== rm.Id);
            this.rm.Projects.push(rm);

            this.grid.update(rm.Properties);
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (SaveViewFinishedProjectsPageCommandV1.matchType(cmd))
        {
            alert("Saved");
        }
        else if (SetLifecycleResumedCommandV1.matchType(cmd))
        {
            const projectId = correlationId;

            this.rm.Projects = this.rm.Projects.filter(a => a.Id !== projectId);
            this.grid.removeRowById(projectId);

            this.projectResumedLifecycleSetter.close();
        }
    }
}